import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Cookies from "js-cookie";
import router from "../router";
import frontstage from "./frontstage";
import backstage from "./backstage";
import custom from "./custom";
import customizeMetalData from "./customizeMetalData";

Vue.use(Vuex);
const member = {
  state: {
    token: "",
    //用來判斷資料loading完成，因爲新會員可能沒有任何資料
    isLoading: "",
    info: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      country: "",
      postalCode: "",
      address: ""
    }
  },
  mutations: {
    setToken: (state, payload) => {
      state.token = payload;
    },
    tokenGetMemberInfo: (state, payload) => {
      state.info = payload;
    },
    setLoadingFinish: (state, payload) => {
      state.isLoading = payload;
    },
    loginOut: state => {
      state.token = "";
      state.info = "";
      state.isLoading = false;
    }
  },
  actions: {
    setToken: (context, payload) => {
      context.commit("setToken", payload);
    },
    tokenGetMemberInfo: context => {
      axios({
        url: context.getters.getMemberGlobalUrl + "users/info",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + context.getters.getToken
        }
      })
        .then(response => {
          if (response.data.data.specialMember === null) {
            context.rootState.frontstage.specialMemberState =
              response.data.data.specialMember;
          } else {
            context.rootState.frontstage.specialMemberState =
              response.data.data.specialMember.is_active;
            if (response.data.data.specialMember.is_active === 1) {
              context.dispatch("tokenGetSpecialMemberData");
            }
          }
          context.commit("tokenGetMemberInfo", response.data.data.info);
          if (response.status == 200) {
            context.commit("setLoadingFinish", true);
          }
        })
        .catch(() => {
          context.commit("setToken", "");
          Cookies.remove("goldUser");
          router.push("/gold/homepage");
        });
    },
    tokenSetMemberInfo: (context, payload) => {
      axios({
        // url: "https://private-anon-49fa9fce21-goldkingdom.apiary-mock.com/api/users/info",
        url: context.getters.getMemberGlobalUrl + "users/info",
        method: "put",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + context.getters.getToken
        },
        data: payload
      })
        .then(() => {
          alert("儲存成功");
          context.dispatch("tokenGetMemberInfo");
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    loginOut: context => {
      context.commit("loginOut");
      context.rootState.frontstage.specialMemberState = "";
      Cookies.remove("goldUser");
    }
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getMemberInfo: state => {
      return state.info;
    },
    getIsLoading: state => {
      return state.isLoading;
    },
    getMemberGlobalUrl: (state, getters, rootState, rootGetters) => {
      return rootGetters.getGlobalUrl;
    }
  }
};

export default new Vuex.Store({
  modules: {
    member: member,
    custom,
    frontstage,
    backstage,
    customizeMetalData
  },
  state: {
    deviceSize: "",
    globalUrl: process.env.VUE_APP_API_URL,
    // globalUrl: "https://stage.kingdom9999.tw/api/api/",
    //前臺
    viewNewsId: "",
    singleId: "",
    sameCompanyOrderId: "",
    isGoToStep3: "",
    //後臺
    adminOrderDetailId: "",
    printInfo: "",
    printLoading: false,
    printInvoice: false
  },
  mutations: {
    setDeviceSize: (state, payload) => {
      state.deviceSize = payload;
    },
    setSingleId: (state, payload) => {
      state.singleId = payload;
    },
    setAdminOrderDetailId: (state, payload) => {
      state.adminOrderDetailId = payload;
    },
    setPrintInfo: (state, payload) => {
      state.printInfo = payload;
    },
    setPrintLoading: (state, payload) => {
      state.printLoading = payload;
    },
    setPrintInvoice: (state, payload) => {
      state.printInvoice = payload;
    },
    setViewNewsId: (state, payload) => {
      state.viewNewsId = payload;
    },
    setSameCompanyOrderId: (state, payload) => {
      state.sameCompanyOrderId = payload;
    },
    setIsGoToStep3: (state, payload) => {
      state.isGoToStep3 = payload;
    }
  },
  actions: {
    setDeviceSize: (context, payload) => {
      context.commit("setDeviceSize", payload);
    },
    setSingleId: (context, payload) => {
      context.commit("setSingleId", payload);
    },
    setAdminOrderDetailId: (context, payload) => {
      context.commit("setAdminOrderDetailId", payload);
    },
    setPrintInfo: (context, payload) => {
      context.commit("setPrintInfo", payload);
    },
    setPrintLoading: (context, payload) => {
      context.commit("setPrintLoading", payload);
    },
    setPrintInvoice: (context, payload) => {
      context.commit("setPrintInvoice", payload);
    },
    setViewNewsId: (context, payload) => {
      context.commit("setViewNewsId", payload);
    },
    setSameCompanyOrderId: (context, payload) => {
      context.commit("setSameCompanyOrderId", payload);
    },
    setIsGoToStep3: (context, payload) => {
      context.commit("setIsGoToStep3", payload);
    }
  },
  getters: {
    getDeviceSize: state => {
      return state.deviceSize;
    },
    getSingleId: state => {
      return state.singleId;
    },
    getGlobalUrl: state => {
      return state.globalUrl;
    },
    getAdminOrderDetailId: state => {
      return state.adminOrderDetailId;
    },
    getPrintInfo: state => {
      return state.printInfo;
    },
    getPrintLoading: state => {
      return state.printLoading;
    },
    getPrintInvoice: state => {
      return state.printInvoice;
    },
    getViewNewsId: state => {
      return state.viewNewsId;
    },
    getSameCompanyOrderId: state => {
      return state.sameCompanyOrderId;
    },
    getIsGoToStep3: state => {
      return state.isGoToStep3;
    }
  }
});
